export const LoggerTypes = {
	DISPATCHED: 'Logger/DISPATCHED'
};
